import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { UgoDesignToolsController } from 'cd-eft/services/eftSetApi';
import { PipeNetworkSimulationAndValidationRequestDto } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

export interface IUgoSimulateRunoffStation {
  select?: boolean;
  ugoName?: string;
  alignmentName?: string;
  alignedElementDesignParamsId?: number;
  alignmentDesignElementJsonId?: number;
  numOfDrains?: number;
  connected?: boolean;
  warnings?: string | null;
  createdDate?: number;
  lastChangeDate?: number;
  errorResponse?: any;
}

const { designStore, ugoDesignStore } = stores.AppStore;

export class UGOSimulateRunoffVM {
  @observable loading: boolean = false;

  @action.bound init = async () => {
    if (ugoDesignStore.ugoSummaryStations.length === 0) {
      this.loading = true;
      const ids: number[] = [];
      ugoDesignStore.ugoSummaryList.forEach((el) => ids.push(el.alignedElementDesignParamsId!));
      const payload: PipeNetworkSimulationAndValidationRequestDto = {
        pipeIdList: ids,
        sessionUuid: designStore.projectsStore.currentSessionId,
      };
      try {
        const response = await UgoDesignToolsController.pipeNetworkSimulationAndValidationUsingPOST(payload);
        if (
          response &&
          response.data &&
          response.data.pipeNetworkSimulationResult &&
          response.data.pipeNetworkSimulationResult.length > 0
        ) {
          ugoDesignStore.ugoSummaryStations = response.data.pipeNetworkSimulationResult;
        } else if (response.data.errorResponse) {
          MessageCenter.addNotification(
            response.data.errorResponse.errorMessage!,
            response.data.errorResponse.errorType!,
            response.data.errorResponse.errorCode
          );
        }
      } catch (error) {
        MessageCenter.addError((error as Error).message);
      } finally {
        this.loading = false;
      }
    }
  };

  @action.bound simulateRunoffSave = async () => {
    this.loading = true;
    const payload = { pipeNetworkSimulationResult: ugoDesignStore.ugoSummaryStations };
    try {
      const response = await UgoDesignToolsController.savePipeSimulationAndValidationUsingPOST(payload);
      console.log('response:', response);
      if (!response.data.errorCode && !response.data.errorMessage) {
        MessageCenter.addSuccess('Status is saved');
      } else {
        MessageCenter.addNotification(response.data.errorMessage!, response.data.errorType!, response.data.errorCode);
      }
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      this.loading = false;
    }
  };
}
